import { TranslateService } from '@ngx-translate/core';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { assignModelOptions } from '../../utilities/assign-model-options';
import { CompositeModel } from '../complex/composite.model';
import { MultilineTextModel, ODataTextLineOutModel } from '../primitive/multiline-text.model';

const odataReportTextSet = 'ReportTextSet';

export class ConfirmationReportTextModel extends CompositeModel {
    public reportText: MultilineTextModel;
    public constructor() {
        super('ConfirmationReportTextModel');

        // Dependency injection
        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const translate = injector.get(TranslateService);

        // the field is required in PACE US.
        this.reportText = <MultilineTextModel>this.set(new MultilineTextModel(odataReportTextSet));
        modelOptionsLoader.load(this.reportText, 'ReportText', 'ReportTextField');
        const rowAmount = 6;
        this.reportText = assignModelOptions(
            this.reportText,
            {
                ...this.reportText.options,
                placeholder: <string>translate.instant('CONFIRMATION_REPORT_TEXT_PLACEHOLDER', {
                    length: this.reportText.options.maxLength,
                }),
                rows: rowAmount,
            },
            this,
        );
    }

    public toJSON(): unknown {
        return {
            reportText: this.reportText.value,
        };
    }
}

export class ConfirmationReportTextModelFromJson extends ConfirmationReportTextModel {
    public constructor(data: JsonConfirmationReportTextModel) {
        super();
        this.reportText.value = data.reportText;
    }
}

export interface JsonConfirmationReportTextModel {
    reportText: string;
}

export interface ODataConfirmationReportTextOutModel extends ODataObject {
    ReportTextSet: ODataTextLineOutModel[];
}
